/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ArchiveReason {
  DELETED_ORDER = 'deleted_order',
  DELETE_EVENT = 'delete_event',
  DELETE_COURSE = 'delete_course',
  CUSTOMER_CANCELED = 'customer_canceled',
  AUTO_CANCELED_MIN_PARTICIPANTS = 'auto_canceled_min_participants',
  ADMIN_RESCHEDULED = 'admin_rescheduled',
  SCHEDULE_REGENERATED = 'schedule_regenerated',
  EXTERNAL_VOUCHER_REJECTED = 'external_voucher_rejected',
  EXPIRED = 'expired',
  PENDING_CONFIRMATION_REJECTED = 'pending_confirmation_rejected',
}
